import { ExtraFieldsExternal, IAvailableTemplate } from '@shared/store/templates/types/templates';
import { IDuration } from '@shared/types/duration';
import { Id } from '@shared/types/global';

export enum DownloadStatus {
    PENDING = 'PENDING',
    DONE = 'DONE',
    CANCEL = 'CANCEL',
    ERROR = 'ERROR',
}

export enum DownloadFilters {
    ALL = 'ALL',
    USER = 'USER',
}

export interface IDownload {
    id: number;
    name: string;
    duration: IDuration;
    extra_fields: ExtraFieldsExternal;
    status: DownloadStatus;
    created_at: string;
    template: number;
    user: number;
    portrait: number[];
    path_zip: string | null;
    preview_gif?: string;
    preview_image?: string;
    preview_video?: string;
    path_video?: string;
}

export interface IDownloadPerCent extends Omit<IDownload, 'extra_fields'> {
    render_progress?: string;
    message?: string;
}

export interface IDownloadCount {
    done: number;
    pending: number;
}

export interface IDownloadActiveLog {
    id: Id;
    template: IAvailableTemplate;
    log_text: string;
    activity_type: string;
    created_at: string;
    user: number;
}

export enum DownloadActivityLog {
    CREATE = 'CREATE',
    READ = 'READ',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
}

export type IDownloadActivityLogRequest = Partial<{
    activity_type: DownloadActivityLog;
    ordering: string;
    page: number | string;
    template: number;
    user: Id;
}>;

export type IDownloadRequest = Partial<{
    created_at_after: string;
    created_at_before: string;
    ordering: string;
    page: number | string;
    search: string;
    status: DownloadStatus;
    template: number;
    user: number;
    filter: DownloadFilters;
}>;
